import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

/**
 * How To Win banner experiment.
 * Treatment: show "How To Win" educational banner on entry pages and restyled "how to win" page.
 * Control: no banner.
 *
 * @returns true when user is in treatment variant
 */
export const useHowToWinBannerExperiment = () =>
    useAmplitudeExperimentBase(AmplitudeExperiments.HowToWinBanner, AmplitudeVariants.HowToWinBanner.Treatment);
